import { isFutureUnixTime, isPastUnixTime } from '@csp/csp-common-date-util';
import { OrgAccessRef } from '@csp/csp-common-model';
import { AccessRefType, AccessRefV1 } from '@csp/dmdp-api-user-dto';
import { AccessRefInV1 } from '@csp/dmdp-api-user-mgmt-dto';

const from = (accessRef: AccessRefV1): OrgAccessRef => ({
  orgId: accessRef.ref,
  parentOrgIds: accessRef.partOf,
  fromUtc: accessRef.fromUtc,
  toUtc: accessRef.toUtc,
  isActive:
    (!accessRef.fromUtc || isPastUnixTime(accessRef.fromUtc)) &&
    (!accessRef.toUtc || isFutureUnixTime(accessRef.toUtc)),
});

const fromAccessRefs = (accessRefs: AccessRefV1[]): OrgAccessRef[] =>
  accessRefs.filter(accessRef => accessRef.type === AccessRefType.ORGANISATION).map(from);

const toAccessRefInV1 = (orgAccessRef: OrgAccessRef): AccessRefInV1 => ({
  ref: orgAccessRef.orgId,
  type: AccessRefType.ORGANISATION,
  fromUtc: orgAccessRef.fromUtc,
  toUtc: orgAccessRef.toUtc,
});

export const OrgAccessRefMapper = {
  from,
  fromAccessRefs,
  toAccessRefInV1,
};
